import * as types from '@/store/mutations'
import api from '@/services/customers'
import i18n from '@/i18n'
const $t = i18n.global.t

const state = {
  customers: [],
  prefill: {
    first: '',
    last: ''
  },
  filters: {
    filterPageOpen: false,
    activeTags: {
      builtin: [], // ['vip', 'host', 'customer', 'dealer', 'profile']
      custom: []   // [1830, 2926]
    }
  },
  merge: {
    popupOpen: false,
    target: null,
    merging: false
  },
  messages: {
    popupOpen: false,
    preSelectedCustomer: null,
    preSelectedAction: null // email | sms
  }

}

const getters = {
  customers: (state) => state.customers,
  getCustomer: (state) => (id) => {
    if(!parseInt(id)){
      return null
    }
    if(state.customers.length == 0 ){
      return null
    }

    let customers = state.customers.filter((customer) => { return parseInt(id) === parseInt(customer.id)});
    if(customers.length > 0){
      let cust = Object.assign({}, customers[0])
      return cust
    } else {
      return null
    }
  },
  getCustomers: (state) => (length, filtered, isOnlyHost = false) => {
    if(filtered.length > 0){
      let array = state.customers.filter((cust) => {
        return cust?.firstName.toUpperCase().indexOf(filtered.toUpperCase())  >= 0 ||
          cust?.lastName.toUpperCase().indexOf(filtered.toUpperCase())  >= 0
      }).slice(0,length)


      if(isOnlyHost){
        return array.filter((cust) => {
          return cust.isHost
        })
      }

      return array
    }

    if(isOnlyHost){
      return state.customers.filter((cust) => {
        return cust.isHost
      }).slice(0, length)
    }

    return state.customers.slice(0,length)
  },
  getFilteredCustomers: (state) => (filtered) => {
    if(filtered.length > 2){
      return state.customers.filter((cust) => {

        let fName = cust?.firstName?.trim().toUpperCase() ?? ""
        let spacer = " "
        let lName = cust?.lastName?.trim().toUpperCase() ?? ""

        let postCode = cust?.primaryAddress?.postCode?.trim().toUpperCase() ?? ""
        let postLocation = cust?.primaryAddress?.postLocation?.trim().toUpperCase() ?? ""

        let mobile = cust?.mobile?.replace(/[^\d]/,'') ?? ""

        let fullName = fName.concat(spacer).concat(lName)
        let fullSearchString = fullName.concat(spacer).concat(postCode).concat(spacer).concat(postLocation).concat(spacer).concat(mobile)
        //return fullName.indexOf(filtered.toUpperCase()) >= 0
        //console.log("Searching: [" + fullSearchString + "] : " + fullSearchString.indexOf(filtered.toUpperCase()))
        return fullSearchString.indexOf(filtered.toUpperCase()) >= 0



        // return cust?.firstName.toUpperCase().indexOf(filtered.toUpperCase())  >= 0 ||  cust?.lastName.toUpperCase().indexOf(filtered.toUpperCase())  >= 0
      })
    }

    return state.customers
  },
  getCustomersAlphabetic: (state, getters)  => (filtered) => {
    let custs  = getters.getFilteredCustomers(filtered).filter((c) => {
      return c.firstName?.length > 0
    });

    let letters = new Map()
    custs.sort((a, b) => a.firstName.localeCompare(b.firstName)).map((c) => {
      if(!letters.has(c.firstName.substr(0,1).toUpperCase())){
        letters.set(c.firstName.substr(0,1).toUpperCase(), [])
      }
      letters.get(c.firstName.substr(0,1).toUpperCase()).push(c)
    })

    return letters
  },
  getCustomersFromParty: (state)  => (party) => {
    if(party === null){
      return []
    }

    let custs  = state.customers.filter((cust) => { return party.customerOrders.filter((order) => { return parseInt(order.customer.id) == parseInt(cust.id )}).length > 0})

    let returnedCusts = custs.map((cust) => {
      let orders = party.customerOrders.filter((order) => {  return parseInt(order.customer.id) == parseInt(cust.id )  })
      cust.order = orders[0]
    })

    return returnedCusts
  },
  tagUsage: (state, getters) => {
    let counter = new Map()
    for(let {tags} of getters.customers){
      if(!tags?.length) {
        continue
      }
      for(let tag of tags){
        if(!counter.has(tag.id)){
          counter.set(tag.id, 0)
        }
        counter.set(tag.id, counter.get(tag.id)+1)
      }
    }
    return counter
  },
  tags: (state, getters) => {
    let raw = getters.dealer?.tags || []
    let tags = {
      builtin: {
        vip: $t('form.filter.tags.vip'),
        host: $t('form.filter.tags.host'),
        customer: $t('form.filter.tags.customer'),
        dealer: $t('form.filter.tags.dealer'),
        profile: $t('form.filter.tags.fromProfile'),
      },
      custom: raw.reduce((tags, {id, tag, active}) => {
        if(active){
          tags[id] = tag
        }
        return tags
      } , {})
    }

    return tags
  }
}

const actions = {
  getCustomer({ commit }, payload ) {
    return new Promise((resolve, reject) => {
      let cust = state.customers.filter((filteredCust)=>{return filteredCust.id === payload})
      if(cust.length > 0){
        resolve(cust[0])
      }
      api.customer(payload).then( res => {
        if(res){
          commit(types.REPLACE_CUSTOMER, res)
          resolve(res)
        }
      }).catch((e) => {
        reject(e)
      })
    })
  },

  getCustomerOrderlist(context,payload) {
    return new Promise((resolve,reject) => {
      api.orderlist(payload).then( res => {
        if(res){
          resolve(res)
        }
      }).catch((e) => {
        reject(e)
      })
    })
  },

  addCustomer({commit}, payload ) {
    return new Promise((resolve, reject) => {
      let req = {
        isHost: payload.isHost,
        isVip: payload.isVip ?? false,
        isCustomer: payload.isCustomer,
        isDealer: payload.isDealer ?? false,
        isFromProfile: payload.isFromProfile ?? false,
        firstName: payload.firstName,
        lastName: payload.lastName,
        mobile: payload.mobile,
        email: payload.email,
        addressLine1: payload.primaryAddress.addressLine1,
        postCode: payload.primaryAddress.postCode,
        postLocation: payload.primaryAddress.postLocation
      }
      if(payload.id > 0){
        api.saveCustomer(payload.id, req).then( res => {
          window.sessionStorage.removeItem('customerCache')
          window.sessionStorage.removeItem('customerCacheLifetime')
          actions.loadAllCustomers({commit})
          resolve(res)
        }).catch((e) => {
          reject(e)
        })

      } else {
        api.addCustomer(req).then( res => {
          window.sessionStorage.removeItem('customerCache')
          window.sessionStorage.removeItem('customerCacheLifetime')
          actions.loadAllCustomers({commit})
          resolve(res)
        }).catch((e) => {
          reject(e)
        })
      }
    })
  },
  saveCustomer(store, {id, payload}){
    return new Promise((resolve, reject) => {
      api.saveCustomer(id, payload).then( res => {
        window.sessionStorage.removeItem('customerCache')
        window.sessionStorage.removeItem('customerCacheLifetime')
        store.dispatch('loadAllCustomers', true).then(()=>{
          resolve(res)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  loadAllCustomers({ commit }, force = false){
    return new Promise((resolve, reject) => {

      let usingCache = false
      const existingCache = JSON.parse(window.sessionStorage.getItem('customerCache'))
      const existingCacheLifetime = JSON.parse(
        window.sessionStorage.getItem('customerCacheLifetime')
      )

      if (existingCache && existingCacheLifetime) {
        if (existingCache.length > 0 && existingCacheLifetime > Date.now()) {
          commit(types.SET_CUSTOMERS, existingCache)
          resolve(1)
          usingCache = true
        }
      }

      if (usingCache === false || force) {
        api.customerList().then( res => {
          const customers = []
          res.forEach((cust) => {
            customers.push(cust)
          })

          commit(types.SET_CUSTOMERS, customers)

          window.sessionStorage.setItem(
            'customerCache',
            JSON.stringify(customers)
          )
          const addedTime =  new Date();
          const newLifetime = addedTime.setMinutes(addedTime.getMinutes() + 20)
          window.sessionStorage.setItem(
            'customerCacheLifetime',
            JSON.stringify(newLifetime)
          )

          resolve(1)
        }).catch((ex) => {
          reject(ex)
        })
      }
    })
  },
  activateFilterTag(store, id){
    let all = store.getters.tags
    store.commit(types.ACTIVATE_FILTER_TAG, {id, all})
  },
  addTag(store, {customerId, tagId}){
    if(tagId in store.getters.tags.builtin){
      let payload = {}
      if(tagId === 'vip'){
        payload.isVip = true
      }
      if(tagId === 'dealer'){
        payload.isDealer = true
      }
      if(tagId === 'host'){
        payload.isHost = true
      }
      if(tagId === 'customer'){
        payload.isCustomer = true
      }
      if(tagId === 'profile'){
        payload.isFromProfile = true
      }

      return store.dispatch('saveCustomer', {id: customerId, payload})
    }

    return api.addTag(customerId, tagId)
  },
  removeTag(store, {customerId, tagId}){
    if(tagId in store.getters.tags.builtin){
      let payload = {}
      if(tagId === 'vip'){
        payload.isVip = false
      }
      if(tagId === 'dealer'){
        payload.isDealer = false
      }
      if(tagId === 'host'){
        payload.isHost = false
      }
      if(tagId === 'customer'){
        payload.isCustomer = false
      }
      return store.dispatch('saveCustomer', {id: customerId, payload})
    }
    return api.removeTag(customerId, tagId)
  },
  async createTag(store, tagName){
    try {
      let tag = await api.createTag(tagName)
      return tag?.primaryObject
    } catch(err) {
      return false
    }
  },
  async mergeCustomers(store, {current, target}){
    try {
      store.commit(types.MERGING_STATUS_ENABLE)
      let resultCustomer = await api.mergeCustomers({current, target})
      await store.dispatch('loadAllCustomers', true)
      return resultCustomer.primaryObject.id
    } catch(err) {
      return err
    } finally {
      store.commit(types.MERGING_STATUS_DISABLE)
    }
  },
  async sendMessageToCustomers(store, payload){
    try {
      let resultCustomer = await api.sendMessageToCustomers(payload)
      return resultCustomer.primaryObject.id
    } catch(err) {
      return err
    }
  },

  async deleteCustomer(store, customerId){
    return api.deleteCustomer(customerId)
  }

}

const mutations = {
  [types.SET_CUSTOMERS](state, payload){
    state.customers = payload
  },
  [types.REPLACE_CUSTOMER](state, payload){
    let foundIndex = state.customers.findIndex((item) => {
      item.id === payload.id
    })
    if(foundIndex){
      state.customers[foundIndex] = payload
    } else {
      state.customers.push(payload)
    }
  },
  [types.SET_CREATECUSTOMER_PREFILL](state, _name){
    let name = _name.toString().trim()
    let parts = name.split(' ')

    if(!parts.length){
      return
    }
    state.prefill.first = parts[0].trim()

    if(!parts[1]){
      return
    }
    state.prefill.last = parts[1].trim()
  },
  [types.CLEAR_CREATECUSTOMER_PREFILL](state){
    state.prefill.first = ''
    state.prefill.last = ''
  },
  [types.SET_CREATEHOST_DATEANDDATA](state, payload){
    state.prefill.date = payload.prefilledDate
    state.prefill.redirect = payload.redirect
  },
  [types.CLEAR_FILTER_TAG](state, id){
    let index = -1
    let type = null // builtin | custom

    let i = state.filters.activeTags.builtin.indexOf(id)
    if(i !== -1){
      type = 'builtin'
      index = i
    }
    if(!type){
      i = state.filters.activeTags.custom.indexOf(parseInt(id))
      if(i !== -1){
        type = 'custom'
        index = i
      }
    }
    if(!type){
      i = state.filters.activeTags.custom.indexOf(id)
      if(i !== -1){
        type = 'custom'
        index = i
      }
    }
    if(!type){
      console.warn(`tagid ${id} (${typeof id}) "not found in active builtin or custom tags`)
      return
    }
    if(!['builtin', 'custom'].includes(type)){
      console.warn(`invalid tag type:", ${type}, "but expecting 'builtin' or 'custom'`)
      return
    }

    state.filters.activeTags[type].splice(index,1)
  },
  [types.ACTIVATE_FILTER_TAG](state, {id, all}){
    let type = null
    if(id in all.builtin){
      type = 'builtin'
    }

    if(!type &&  all.custom[id.toString()]){
      type = 'custom'
    }
    if(!type){
      console.warn(`tagid ${id} (${typeof id}) "not found in known builtin or custom tags:`)
      return
    }
    if(!['builtin', 'custom'].includes(type)){
      console.warn(`invalid tag type:", ${type}, "but expecting 'builtin' or 'custom'`)
      return
    }

    // make sure custom tag id is always int
    id = type === 'custom'? parseInt(id) : id

    let alreadyActive = state.filters.activeTags[type].indexOf(id) !== -1

    if(alreadyActive){
      //console.log(`${type} tag ${id}: "${all[type][id]}" already active`)
      return
    }

    state.filters.activeTags[type].unshift(id)
  },
  [types.CLEAR_ALL_FILTERS](state){
    state.filters.activeTags.builtin = []
    state.filters.activeTags.custom = []
  },
  [types.UPDATE_ALL_TAGS_STATUSES](state, {builtin, custom}){
    state.filters.activeTags.builtin = builtin
    state.filters.activeTags.custom = custom
  },
  [types.OPEN_FILTERPAGE](state){
    state.filters.filterPageOpen = true
  },
  [types.CLOSE_FILTERPAGE](state){
    state.filters.filterPageOpen = false

  },
  [types.OPEN_MERGEFORM](state){
    state.merge.popupOpen = true
  },
  [types.MERGE_PICKTARGET](state, target){
    state.merge.target = target
  },
  [types.CLOSE_MERGEFORM](state){
    state.merge.mergeTarget = null
    state.merge.popupOpen = false
  },
  [types.MERGING_STATUS_ENABLE](state){
    state.merge.merging = true
  },
  [types.MERGING_STATUS_DISABLE](state){
    state.merge.merging = false
  },
  [types.OPEN_SMSFORM](state){
    state.messages.preSelectedAction = 'sms'
    state.messages.popupOpen = true
  },
  [types.OPEN_EMAILFORM](state){
    state.messages.preSelectedAction = 'email'
    state.messages.popupOpen = true
  },
  [types.CLOSE_MESSAGEFORM](state){
    state.messages.popupOpen = false
  },
  [types.CLEAR_MESSAGES_PRESELECTION](state){
    state.messages.preSelectedCustomer = null
    state.messages.preSelectedAction = null
  },
  [types.SAVE_MESSAGES_PRESELECTION](state, id){
    state.messages.preSelectedCustomer = id
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
